import { CreatePaymentLink, InitPayment } from "../models/PaymentLink";
import axiosInstance from "./axiosInstance";

const generatePaymentLink = async (Link: Partial<CreatePaymentLink>) => {
  const response = await axiosInstance.post("payments/create-link", Link);
  return response.data;
};

const getAllPaymentLinks = async () => {
  const response = await axiosInstance.get("payments/admin/payment-link");
  return response.data;
};

const getPaymentLinkByUser = async (user_id: string) => {
    const response = await axiosInstance.get(`payments/payment-link/all/${user_id}`);
    return response.data;
  };

const initPayment = async (link_id: string) => {
  const response = await axiosInstance.get(`payments/init/payment-link/${link_id}`);
  return response.data;
};

const initPaymentLinkTransaction = async (payment: Partial<InitPayment>) => {
  // Harmonisé avec la route payment-link utilisée partout
  const response = await axiosInstance.post("payments/payment-link/init", payment);
  return response.data;
};

const PaymentLinkCheckStatus = async (link_id: string) => {
  // Harmonisé avec la route init payment-link
  const response = await axiosInstance.get(`payments/payment-link/check-status/${link_id}`);
  return response.data;
};

export const paymentLinkService = {
  generatePaymentLink,
  getPaymentLinkByUser,
  getAllPaymentLinks,
  initPayment,
  initPaymentLinkTransaction,
  PaymentLinkCheckStatus
  
};
